// src/lib/config.js
// Site-wide configuration constants.

/**
 * External scheduling link for the "Book the AI LIFT" CTA.
 * UsefulBots-branded TidyCal booking page. Absolute https:// links are
 * rendered by the Button component as new-tab external links.
 */
export const BOOKING_URL = 'https://bookme.usefulbots.com/';

/** Route where the AI LIFT offer page lives. */
export const REALITY_CHECK_PATH = '/ai-lift';

/** Public contact email. */
export const CONTACT_EMAIL = 'team@downtoearthguides.com';

/** Price framing for the AI LIFT (kept in one place for easy edits). */
export const REALITY_CHECK_PRICE = '$1,500–$3,500';
